export const COUNTRY_CITIES = {
    Australia: ["Sydney", "Melbourne", "Daylesford"],
    // Australia: ["Sydney", "Melbourne", "Daylesford", "Brisbane", "Cairns", "Perth", "Adelaide", "Hobart"],

};

export const getCountries = () => Object.keys(COUNTRY_CITIES);

export const getCities = (country) => COUNTRY_CITIES[country] || [];
